import { Component } from "@angular/core";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { EdiForecastService } from "@services/ediForecast.service";
import { EdiOrderService } from "@services/ediOrder.service";
import { ExportLogService } from "@services/exportLog.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "ediSummary",
	styleUrls: ["ediSummary.css"],
	templateUrl: "ediSummary.html"
})

export class EdiSummaryAdminComponent {
	ediForecasts: any;
	ediForecastsGridLoading = false;
	ediOrders: any;
	ediOrdersGridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "showOrders", text: "Orders" }, { method: "showForecasts", text: "Forecasts" }];
	mode = "Orders";
	title = "Edi Orders Summary";
	
	constructor(private toastService: ToastService, private ediForecastService: EdiForecastService, private ediOrderService: EdiOrderService, private exportLogService: ExportLogService) {
		this.getForecasts();
		this.getOrders();
	}

	getForecasts() {
		this.ediForecastsGridLoading = true;
		this.ediForecastService.futureSummary()
			.subscribe(
				(res: any) => {
					this.ediForecasts = res.response;
					this.ediForecastsGridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getOrders() {
		this.ediOrdersGridLoading = true;
		this.ediOrderService.futureSummary()
			.subscribe(
				(res: any) => {
					this.ediOrders = res.response;
					this.ediOrdersGridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logEdiForecastsExport() {
		const logExport = new LogExport();
		logExport.gridName = "EDI Forecast Summary";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	logEdiOrdersExport() {
		const logExport = new LogExport();
		logExport.gridName = "EDI Order Summary";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	showForecasts() {
		this.mode = "Forecasts";
		this.title = "EDI Forecasts Summary";
	}

	showOrders() {
		this.mode = "Orders";
		this.title = "EDI Orders Summary";
	}
}